<template>
  <div class="form-group col-12 col-w-full">
    <form action="#" @submit.prevent="setDescription()">
      <div class="col-12 col-w-full mb-4">
        <textarea
          v-model="description"
          autofocus
          class="input-area col-12 col-w-full"
          rows="4"
          :maxlength="short ? 50 : 100"
        />
      </div>
      <div class="row no-gutters mb-4 mt-4">
        <div class="col-6">
          <WhiteLabel class="mb-4 col-w-full">
            <button type="button" @click="returnStep()" class="btn no-focus-effect btn-md w-100">
              Voltar
            </button>
          </WhiteLabel>
        </div>
        <div class="col-6">
          <WhiteLabel class="mb-3 col-w-full">
            <button
              type="submit"
              class="btn btn-md w-100"
              :disabled="!validDestination"
              :class="validDestination? 'btn-orange' : 'btn-gray-disabled'">
              Continuar
            </button>
          </WhiteLabel>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// component imports
import WhiteLabel from '@/components/shared/WhiteLabel';

export default {
  name: 'SetOrderDescriptionModalSection',

  components: {
    WhiteLabel,
  },

  props: {
    preLoadedDescription: {
      type: String,
      required: false,
      default: '',
    },
    short: {
      type: Boolean,
      required: false,
      default: false,
    },
    destination: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    description: null,
  }),

  mounted() {
    if (this.preLoadedDescription) this.description = this.preLoadedDescription;
  },
  computed: {
    validDestination() {
      return !this.destination.isRecurrence || (this.description && this.description.length > 0);
    },
  },
  methods: {
    setDescription() {
      this.$emit('set-description', this.description);
    },
    returnStep() {
      this.$emit('return-step');
    },
  },
};
</script>
